








import { Vue, Component, Watch } from 'vue-property-decorator';
import '@gig/magic-messaging';
import { isMobileQuery } from '@gig/magic-common';

@Component
export default class MessagesPage extends Vue {
    @Watch('$route.path')
    async onRouteChange() {
        const isMobile = await isMobileQuery();
        if(isMobile){
            window.scrollTo({
                top: 0,
            });
        }
    }
}
